import { render } from "./Security.vue?vue&type=template&id=09a4cfe3"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/user/Security.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09a4cfe3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09a4cfe3', __exports__)) {
    api.reload('09a4cfe3', __exports__)
  }
  
  module.hot.accept("./Security.vue?vue&type=template&id=09a4cfe3", () => {
    api.rerender('09a4cfe3', render)
  })

}


export default __exports__